import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Check({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'18px'} height={'13px'} viewBox={'0 0 18 13'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-3.000000, -5.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M19.2928932,5.29289322 C19.6834175,4.90236893 20.3165825,4.90236893 20.7071068,5.29289322 C21.0976311,5.68341751 21.0976311,6.31658249 20.7071068,6.70710678 L9.70710678,17.7071068 C9.31658249,18.0976311 8.68341751,18.0976311 8.29289322,17.7071068 L3.29289322,12.7071068 C2.90236893,12.3165825 2.90236893,11.6834175 3.29289322,11.2928932 C3.68341751,10.9023689 4.31658249,10.9023689 4.70710678,11.2928932 L9,15.5857864 L19.2928932,5.29289322 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Check.propTypes = {
  className: PropTypes.string,
}
